<template>
  <div class="music-player">
    <div>
      <b>Probe hören</b>
    </div>
    <div class="control">
      <div class="p-icon">
        <PlayIcon v-if="!playing" title="play" @click="play" />
        <PauseIcon v-else title="pause" @click="pause" />
      </div>
      <div class="s-icon">
        <StopIcon title="stop" class="stop-icon" @click="stop" />
      </div>
      <VueSlider
        v-model="volume"
        class="volume-slider"
        @change="updateVolume"
      />
    </div>
  </div>
</template>

<script>
import { Howl, Howler } from "howler";
import VueSlider from "vue-slider-component";
import PlayIcon from "vue-material-design-icons/Play";
import StopIcon from "vue-material-design-icons/Stop";
import PauseIcon from "vue-material-design-icons/Pause";

export default {
  name: "MusicPlayer",
  components: {
    VueSlider,
    PlayIcon,
    StopIcon,
    PauseIcon
  },
  props: {
    path: { type: String, default: "" }
  },
  data() {
    return {
      sound: null,
      volume: 50,
      playing: false
    };
  },
  watch: {
    path: {
      handler: function(newVal) {
        this.unloadMusic();
        if (newVal !== "") {
          let self = this;
          this.sound = new Howl({
            src: newVal,
            html5: true,
            onend: function() {
              self.playing = false;
            }
          });
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.unloadMusic();
  },
  methods: {
    play() {
      if (this.sound !== null) {
        this.playing = true;
        this.sound.play();
      }
    },
    pause() {
      if (this.sound !== null) {
        this.playing = false;
        this.sound.pause();
      }
    },
    stop() {
      if (this.sound !== null) {
        this.playing = false;
        this.sound.stop();
      }
    },
    updateVolume(newVal) {
      let float = parseFloat(newVal / 100);
      Howler.volume(float);
    },
    unloadMusic() {
      if (this.sound !== null) this.sound.unload();
      this.playing = false;
    }
  }
};
</script>

<style scoped>
.music-player {
  margin-top: 10px;
  margin-bottom: 20px;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  justify-self: center;
}

.control {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.volume-slider {
  min-width: 100px;
  align-self: center;
}

.p-icon,
.s-icon {
  cursor: pointer;
  padding-right: 10px;
}

.p-icon:hover {
  color: rgba(0, 167, 255, 1);
}

.s-icon:hover {
  color: black;
}
</style>
